import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import heroImage from "../assets/hero-coldroom.jpg";
import client1 from "../assets/emvezowildlife.jpg";
import client2 from "../assets/healthdepartmentkzn.jpg";
import client3 from "../assets/avbob.jpg";
import client4 from "../assets/msingamunicipality.jpg";
import client5 from "../assets/Eskom.png";
import client6 from "../assets/ethekwinimetro.jpg";
import client7 from "../assets/nelsonmandelametro.png";

import client8 from "../assets/Ukzn.jpg";
import client9 from "../assets/USHAKA.webp";
import client10 from "../assets/toyota.webp";
import client11 from "../assets/strandfoam.webp";
import client12 from "../assets/sharks board.webp";
import client13 from "../assets/national health lab.webp";
import client14 from "../assets/mabhida stadium.webp";
import client15 from "../assets/lancet.webp";
import client16 from "../assets/dut.webp";

const clients = [
  { name: "Emvezo Wildlife", src: client1 },
  { name: "Department of Health KZN", src: client2 },
  { name: "AVBOB", src: client3 },
  { name: "Msinga Municipality", src: client4 },
  { name: "Eskom", src: client5 },
  { name: "EThekwini Metro", src: client6 },
  { name: "Nelson Mandela Metro", src: client7 },
  { name: "University of Kwazulu Natal", src: client8 },
  { name: "Ushaka Marine World", src: client9 },
  { name: "Toyota South Africa", src: client10 },
  { name: " Strand Foam ", src: client11 },
  { name: "Sharks Board", src: client12 },
  { name: "National Health Laboratory Service", src: client13 },
  { name: "Moses Mabhida Stadium", src: client14 },
  { name: "Lancet Laboratories", src: client15 },
  { name: "Durban University of Technology", src: client16 },
];

const Clients = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted">
      {/* 🟦 HERO SECTION */}
      <section
        className="bg-cover bg-center text-white py-24 relative"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${heroImage})`,
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Our Valued Clients
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-white/90">
            We are proud to serve leading organizations across South Africa from
            municipalities to major corporations and public institutions.
          </p>
        </div>
      </section>

      {/* 🧊 CLIENTS GRID */}
      <section className="py-20 container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-foreground">
            Trusted by Leading Brands
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Our work speaks for itself. We’re honoured to be the refrigeration
            and air-conditioning partner of choice for top-tier clients who
            value quality, innovation, and reliability.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-8">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{
                scale: 1.07,
                y: -6,
                transition: { type: "spring", stiffness: 220 },
              }}
              className="group relative flex flex-col items-center justify-center cursor-pointer w-full"
            >
              <Card className="shadow-md border-none bg-white rounded-2xl relative overflow-hidden w-full h-[200px] flex items-center justify-center">
                <CardContent className="flex items-center justify-center relative w-full h-full">
                  {/* Logo with zoom */}
                  <motion.img
                    src={client.src}
                    alt={client.name}
                    className="h-20 sm:h-24 md:h-28 object-contain mx-auto z-10"
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.5 }}
                  />

                  {/* Company name overlay */}
                  <div
                    className="
                      absolute
                      bottom-0
                      left-0
                      w-full
                      bg-white
                      text-center
                      py-2
                      opacity-0
                      group-hover:opacity-100
                      transition-opacity
                      duration-300
                      z-20
                      font-semibold
                      text-lg
                      select-none
                    "
                  >
                    {client.name}
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 🟨 CTA SECTION */}
      <section
        className="py-20 text-center text-white bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${heroImage})`,
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Want to Partner with Us?
          </h2>
          <p className="max-w-2xl mx-auto text-white/90 mb-8">
            Become part of our growing network of satisfied clients who trust 3A
            Coldrooms for reliable, high-performance refrigeration and climate
            solutions.
          </p>
          <Button
            variant="secondary"
            size="lg"
            asChild
            className="bg-white text-primary hover:bg-white/90"
          >
            <Link to="/contact">Contact Our Team</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Clients;
